<template>
  <el-dialog v-model="visible" :title="form.id ? '디자인 수정' : '디자인 등록'" width="900px" top="5vh"
             :close-on-click-modal="false" destroy-on-close>
    <el-tabs v-model="activeTab">
      <!-- 탭1: 기본정보 -->
      <el-tab-pane label="기본정보" name="basic">
        <el-form :model="form" :rules="rules" ref="formRef" label-width="110px">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="브랜드" prop="brand">
                <el-select v-model="form.brand" filterable clearable placeholder="브랜드명 검색" style="width: 100%"
                           :filter-method="filterBrands">
                  <el-option v-for="b in filteredBrands" :key="b.id" :label="b.name" :value="b.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="고객사">
                <el-input :model-value="customerInfoText" disabled placeholder="브랜드 선택 시 자동표시" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="내부번호">
                <el-input v-model="form.style_number" disabled placeholder="자동생성" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="고객사 스타일번호">
                <el-input v-model="form.main_style_number" placeholder="예: G11F-H026" />
                <div class="field-hint">메인오더(메인요청) 생성 시 필수 — 고객 관리번호</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="샘플 스타일번호">
                <el-input v-model="form.sample_style_number" placeholder="예: MHC26S-H010" />
                <div class="field-hint">샘플 단계 개발번호 — 생산지시서 Sample No 출력</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="담당MD" prop="designer">
                <el-select v-model="form.designer" filterable clearable placeholder="선택"
                           style="width: 100%" :loading="mdLoading">
                  <el-option v-for="emp in designerOptions" :key="emp.id"
                             :label="emp.name" :value="emp.id" />
                </el-select>
                <div v-if="mdHint" class="md-hint" :class="{ 'md-warn': mdHintWarn }">{{ mdHint }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="요청일" prop="request_date">
                <el-date-picker v-model="form.request_date" type="date" style="width: 100%"
                                value-format="YYYY-MM-DD" placeholder="날짜 선택" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="년도" prop="year">
                <el-select v-model="form.year" filterable placeholder="년도" style="width: 100%">
                  <el-option v-for="y in yearOptions" :key="y" :label="String(y)" :value="y" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="시즌" prop="season">
                <el-select v-model="form.season" style="width: 100%">
                  <el-option label="SS" value="SS" />
                  <el-option label="FW" value="FW" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="구분">
                <el-select v-model="form.sample_main_type" style="width: 100%">
                  <el-option label="샘플" value="SAMPLE" />
                  <el-option label="메인" value="MAIN" />
                  <el-option label="샘플+메인" value="BOTH" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="브랜드측 담당자">
                <el-input v-model="form.brand_contact" placeholder="고객사 디자이너/MD" />
                <div class="field-hint">고객사 직원 — 우리 직원은 위 [담당MD]에</div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-divider content-position="left">품명/분류</el-divider>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="성별">
                <el-select v-model="form.gender_code" clearable placeholder="선택" style="width: 100%"
                           @change="onCodeChange">
                  <el-option v-for="c in codeStore.designCodes.C04" :key="c.id" :label="c.name" :value="c.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="제품종류">
                <el-select v-model="form.product_type_code" clearable placeholder="선택" style="width: 100%"
                           @change="onCodeChange">
                  <el-option v-for="c in codeStore.designCodes.C05" :key="c.id" :label="c.name" :value="c.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="스타일">
                <el-select v-model="form.style_code" clearable placeholder="선택" style="width: 100%"
                           @change="onCodeChange">
                  <el-option v-for="c in codeStore.designCodes.C06" :key="c.id" :label="c.name" :value="c.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="품명">
                <el-input v-model="form.product_name" placeholder="자동생성 또는 직접 입력" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label=" ">
                <el-button @click="autoGenerateName" :disabled="!form.gender_code && !form.product_type_code && !form.style_code">
                  자동생성
                </el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="제작난이도">
                <el-select v-model="form.difficulty" clearable placeholder="선택" style="width: 100%">
                  <el-option label="하" value="LOW" />
                  <el-option label="중" value="MEDIUM" />
                  <el-option label="상" value="HIGH" />
                  <el-option label="최상" value="VERY_HIGH" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-divider content-position="left">상세 속성</el-divider>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="세트여부">
                <el-switch v-model="form.is_set" active-text="예" inactive-text="아니오" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="라이너구분">
                <el-select v-model="form.liner_type" style="width: 100%">
                  <el-option label="없음" value="NONE" />
                  <el-option label="탈부착" value="DETACHABLE" />
                  <el-option label="고정" value="FIXED" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="리버시블">
                <el-switch v-model="form.is_reversible" active-text="예" inactive-text="아니오" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="메모">
                <el-input v-model="form.memo" type="textarea" :rows="2" placeholder="메모 입력" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>

      <!-- 탭3: 이미지/혼용율 -->
      <el-tab-pane label="이미지/혼용율" name="media">
        <el-divider content-position="left">이미지</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="image-upload-box">
              <p class="image-label">정면이미지</p>
              <el-upload
                :auto-upload="false"
                :show-file-list="false"
                accept="image/*"
                @change="(file) => onImageChange('front_image', file)"
              >
                <div class="image-preview">
                  <el-image v-if="frontImagePreview" :src="frontImagePreview"
                            fit="contain" style="width:200px;height:200px" />
                  <div v-else class="image-placeholder">
                    <span>+ 이미지 선택</span>
                  </div>
                </div>
              </el-upload>
              <el-button v-if="frontImagePreview" size="small" type="danger" @click="clearImage('front_image')"
                         style="margin-top:4px">삭제</el-button>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="image-upload-box">
              <p class="image-label">후면이미지</p>
              <el-upload
                :auto-upload="false"
                :show-file-list="false"
                accept="image/*"
                @change="(file) => onImageChange('back_image', file)"
              >
                <div class="image-preview">
                  <el-image v-if="backImagePreview" :src="backImagePreview"
                            fit="contain" style="width:200px;height:200px" />
                  <div v-else class="image-placeholder">
                    <span>+ 이미지 선택</span>
                  </div>
                </div>
              </el-upload>
              <el-button v-if="backImagePreview" size="small" type="danger" @click="clearImage('back_image')"
                         style="margin-top:4px">삭제</el-button>
            </div>
          </el-col>
        </el-row>

        <el-divider content-position="left">혼용율</el-divider>
        <el-table :data="form.mix_ratios" size="small" border style="width: 100%">
          <el-table-column label="소재명" min-width="200">
            <template #default="{ row }">
              <el-input v-model="row.material_name" size="small" placeholder="예: 폴리에스터" />
            </template>
          </el-table-column>
          <el-table-column label="혼용율(%)" width="140">
            <template #default="{ row }">
              <el-input-number v-model="row.ratio_percent" :min="0" :max="100"
                               :precision="1" size="small" style="width: 100%" />
            </template>
          </el-table-column>
          <el-table-column label="" width="80" align="center">
            <template #default="{ $index }">
              <el-button type="danger" size="small" text @click="removeMixRatio($index)">삭제</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 8px; display: flex; justify-content: space-between; align-items: center">
          <el-button size="small" @click="addMixRatio">+ 소재 추가</el-button>
          <span v-if="mixRatioTotal > 0" :style="{ color: mixRatioTotal === 100 ? '#67C23A' : '#F56C6C' }">
            합계: {{ mixRatioTotal }}%
          </span>
        </div>
      </el-tab-pane>
    </el-tabs>

    <template #footer>
      <div style="display:flex;justify-content:space-between;align-items:center">
        <div>
          <el-button v-if="form.id" :type="form.is_locked ? 'warning' : 'default'" size="small"
                     @click="toggleLock">
            {{ form.is_locked ? '잠금 해제' : '잠금' }}
          </el-button>
        </div>
        <div>
          <el-button @click="visible = false">취소</el-button>
          <el-button type="primary" @click="submit" :disabled="form.is_locked">
            {{ form.id ? '수정' : '등록' }}
          </el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, computed, watch, defineExpose, onMounted } from 'vue'
import axiosInstance from '@/api/axios'
import { useCodeStore } from '@/stores/codeStore'
import { ElMessage } from 'element-plus'

const codeStore = useCodeStore()
const visible = ref(false)
const activeTab = ref('basic')
const formRef = ref()

// 년도 옵션 (현재년도 기준 ±3년)
const currentYear = new Date().getFullYear()
const yearOptions = Array.from({ length: 7 }, (_, i) => currentYear - 3 + i)

// 브랜드 필터링 (초성/부분 검색)
const brandSearchQuery = ref('')
const filteredBrands = computed(() => {
  if (!brandSearchQuery.value) return codeStore.brands
  const q = brandSearchQuery.value.toLowerCase()
  return codeStore.brands.filter(b =>
    b.name.toLowerCase().includes(q) ||
    (b.name_en && b.name_en.toLowerCase().includes(q))
  )
})
const filterBrands = (query) => {
  brandSearchQuery.value = query
}

// 선택된 브랜드 정보 → 고객사 자동 표시
const selectedBrand = computed(() => {
  if (!form.value.brand) return null
  return codeStore.brands.find(b => b.id === form.value.brand)
})

const customerInfoText = computed(() => {
  if (!selectedBrand.value) return ''
  const b = selectedBrand.value
  // 고객사명이 있으면 고객사명 표시, 없으면 브랜드 담당자 표시
  if (b.customer_name) return b.customer_name
  const parts = []
  if (b.contact_person) parts.push(b.contact_person)
  if (b.contact_phone) parts.push(b.contact_phone)
  return parts.join(' / ') || b.name
})

// 이미지 관련
const frontImageFile = ref(null)
const backImageFile = ref(null)
const frontImagePreview = ref(null)
const backImagePreview = ref(null)

const emptyForm = () => ({
  id: null,
  style_number: '',
  main_style_number: '',
  sample_style_number: '',
  brand: null,
  designer: null,
  brand_contact: '',
  request_date: '',
  year: new Date().getFullYear(),
  season: 'SS',
  sample_main_type: 'SAMPLE',
  gender_code: null,
  product_type_code: null,
  style_code: null,
  product_name: '',
  difficulty: null,
  is_set: false,
  liner_type: 'NONE',
  is_reversible: false,
  front_image_url: null,
  back_image_url: null,
  memo: '',
  is_locked: false,
  mix_ratios: [],
})

const form = ref(emptyForm())

// ── 담당MD: 브랜드 MD 배정자 상단 + 전직원(업무지원 부서 제외) (customer-app-design.md §8, 2026-11-03 개정) ──
const mdAssignees = ref([])
const mdLoading = ref(false)
watch(() => form.value.brand, async (brandId) => {
  mdAssignees.value = []
  if (!brandId) return
  mdLoading.value = true
  try {
    const res = await axiosInstance.get('/brand-assignments/', {
      params: { brand: brandId, role: 'MD', is_active: 'true' },
    })
    mdAssignees.value = res.data.results || res.data || []
    // MD 담당이 1명이면 자동 선택 (기존 값이 없을 때만 — 수정 모드 보호)
    if (!form.value.designer && mdAssignees.value.length === 1) {
      form.value.designer = mdAssignees.value[0].employee
    }
  } catch (e) {
    console.error('브랜드 MD 담당 조회 실패:', e)
  } finally {
    mdLoading.value = false
  }
})

// 담당MD 목록에서 제외할 부서 (2026-11-03 제보 이미영: "업무지원부(경영지원부·구매생산부)
// 제외한 전직원"). 부서명 기준 — 부서 개편 시 여기만 고치면 된다.
const MD_EXCLUDED_DEPARTMENTS = ['업무지원부', '경영지원부', '구매생산부']

const designerOptions = computed(() => {
  // 1) 브랜드 담당자 관리에서 MD 로 배정된 직원 — 맨 위 (라벨에 표시)
  const mdIds = new Set(mdAssignees.value.map(a => a.employee))
  const top = mdAssignees.value.map(a => ({ id: a.employee, name: `${a.employee_name} · 브랜드 MD` }))
  // 2) 그 아래 전직원 (업무지원 부서 제외) — 2026-11-03 제보 전까지는 MD 배정자만/담당법인
  //    직원만 보여 "없는 직원 있음" 제보. 배정은 우선순위 표시로만 남기고 선택 폭은 전직원.
  const rest = codeStore.employees
    .filter(e => !mdIds.has(e.id))
    .filter(e => !MD_EXCLUDED_DEPARTMENTS.includes(e.department_name))
    .map(e => ({ id: e.id, name: e.get_full_name || e.username }))
  let opts = [...top, ...rest]
  // 기존 저장값이 목록 밖(제외 부서·퇴사자)이면 유지 표시 — 과거 디자인 수정 시 값 소실 방지
  if (form.value.designer && !opts.some(o => o.id === form.value.designer)) {
    const cur = codeStore.employees.find(e => e.id === form.value.designer)
    if (cur) opts = [{ id: cur.id, name: `${cur.get_full_name || cur.username} (현재 담당 아님)` }, ...opts]
  }
  return opts
})

const mdHint = computed(() => {
  if (!form.value.brand || mdLoading.value) return ''
  if (mdAssignees.value.length) return `브랜드 MD 담당 ${mdAssignees.value.length}명 (상단 표시)`
  return 'MD 미배정 — 브랜드 담당자 관리에서 배정하면 상단에 표시됩니다'
})
const mdHintWarn = computed(() => !!form.value.brand && !mdLoading.value && !mdAssignees.value.length)

const rules = {
  brand: [{ required: true, message: '브랜드를 선택하세요', trigger: 'change' }],
  request_date: [{ required: true, message: '요청일을 선택하세요', trigger: 'change' }],
  year: [{ required: true, message: '년도를 입력하세요', trigger: 'change' }],
  season: [{ required: true, message: '시즌을 선택하세요', trigger: 'change' }],
}

const emit = defineEmits(['saved'])

const mixRatioTotal = computed(() => {
  return (form.value.mix_ratios || []).reduce((sum, r) => sum + (Number(r.ratio_percent) || 0), 0)
})

const open = async (design = null) => {
  activeTab.value = 'basic'
  frontImageFile.value = null
  backImageFile.value = null

  if (design) {
    // 상세 데이터 로드
    try {
      const res = await axiosInstance.get(`designs/${design.id}/`)
      const data = res.data
      form.value = {
        ...emptyForm(),
        ...data,
        mix_ratios: data.mix_ratios || [],
      }
      frontImagePreview.value = data.front_image_url || null
      backImagePreview.value = data.back_image_url || null
    } catch (err) {
      console.error('디자인 상세 조회 실패:', err)
      form.value = { ...emptyForm(), ...design, mix_ratios: [] }
      frontImagePreview.value = design.front_image_url || null
      backImagePreview.value = null
    }
  } else {
    form.value = emptyForm()
    frontImagePreview.value = null
    backImagePreview.value = null
  }

  visible.value = true
}
defineExpose({ open })

const onCodeChange = () => {
  // 코드 변경 시 자동으로 품명 미리보기 (저장 전이므로 클라이언트 측)
}

const autoGenerateName = () => {
  const parts = []
  if (form.value.gender_code) {
    const code = codeStore.designCodes.C04.find(c => c.id === form.value.gender_code)
    if (code) parts.push(code.name + '용')
  }
  if (form.value.product_type_code) {
    const code = codeStore.designCodes.C05.find(c => c.id === form.value.product_type_code)
    if (code) parts.push(code.name)
  }
  if (form.value.style_code) {
    const code = codeStore.designCodes.C06.find(c => c.id === form.value.style_code)
    if (code) parts.push(code.name)
  }
  form.value.product_name = parts.join(' ')
}

const onImageChange = (field, uploadFile) => {
  const file = uploadFile.raw || uploadFile
  if (field === 'front_image') {
    frontImageFile.value = file
    frontImagePreview.value = URL.createObjectURL(file)
  } else {
    backImageFile.value = file
    backImagePreview.value = URL.createObjectURL(file)
  }
}

const clearImage = (field) => {
  if (field === 'front_image') {
    frontImageFile.value = null
    frontImagePreview.value = null
    form.value.front_image_url = null
  } else {
    backImageFile.value = null
    backImagePreview.value = null
    form.value.back_image_url = null
  }
}

const addMixRatio = () => {
  form.value.mix_ratios.push({ material_name: '', ratio_percent: 0 })
}

const removeMixRatio = (index) => {
  form.value.mix_ratios.splice(index, 1)
}

const toggleLock = async () => {
  if (!form.value.id) return
  try {
    const res = await axiosInstance.post(`designs/${form.value.id}/toggle-lock/`)
    form.value.is_locked = res.data.is_locked
    ElMessage.success(res.data.message)
  } catch (err) {
    ElMessage.error('잠금 처리 실패')
  }
}

const submit = async () => {
  try {
    // 기본정보 탭 validation
    if (formRef.value) {
      await formRef.value.validate()
    }

    // 디자인 데이터 저장
    const payload = { ...form.value }
    delete payload.mix_ratios
    delete payload.mix_ratio_text
    // read-only fields 제거
    delete payload.brand_name
    delete payload.designer_name
    delete payload.manufacturer_name
    delete payload.season_display
    delete payload.difficulty_display
    delete payload.liner_type_display
    delete payload.sample_main_type_display
    delete payload.gender_name
    delete payload.product_type_name
    delete payload.style_name
    delete payload.created_at
    delete payload.created_by
    delete payload.updated_at
    delete payload.updated_by

    // 샘플/생산 필드는 각 앱에서 관리 (디자인 폼에서 제외)
    delete payload.sample_completion_date
    delete payload.sample_status
    delete payload.approval_status
    delete payload.order_quantity
    delete payload.due_date
    delete payload.manufacturer
    delete payload.production_status

    let designId = form.value.id
    if (designId) {
      await axiosInstance.put(`designs/${designId}/`, payload)
    } else {
      const res = await axiosInstance.post('designs/', payload)
      designId = res.data.id
    }

    // 이미지 업로드
    if (frontImageFile.value || backImageFile.value) {
      const imgData = new FormData()
      if (frontImageFile.value) imgData.append('front_image', frontImageFile.value)
      if (backImageFile.value) imgData.append('back_image', backImageFile.value)
      await axiosInstance.post(`designs/${designId}/upload-image/`, imgData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
    }

    // 혼용율 저장
    const validRatios = (form.value.mix_ratios || []).filter(
      r => r.material_name && r.ratio_percent > 0
    )
    if (validRatios.length > 0) {
      await axiosInstance.post(`designs/${designId}/mix-ratios/`, validRatios)
    } else if (form.value.id) {
      // 편집 모드에서 모든 혼용율이 삭제된 경우
      await axiosInstance.delete(`designs/${designId}/mix-ratios/`)
    }

    ElMessage.success(form.value.id ? '수정되었습니다' : '등록되었습니다')
    emit('saved')
    visible.value = false
  } catch (err) {
    if (err && err !== false) {
      console.error('저장 오류:', err)
      if (err.response?.data) {
        const data = err.response.data
        const messages = Object.entries(data)
          .map(([key, val]) => `${key}: ${Array.isArray(val) ? val.join(', ') : val}`)
          .join('\n')
        ElMessage.error({ message: messages || '저장 중 오류가 발생했습니다', duration: 5000 })
      } else {
        ElMessage.error('저장 중 오류가 발생했습니다')
      }
    }
  }
}

const loadOptions = async () => {
  await Promise.all([
    codeStore.fetchBrands(),
    codeStore.fetchDesignCodes(),
    codeStore.fetchEmployees(),
  ])
}

onMounted(() => loadOptions())
</script>

<style scoped>
.image-upload-box {
  text-align: center;
}
.image-label {
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 14px;
}
.image-preview {
  border: 1px dashed #dcdfe6;
  border-radius: 8px;
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  cursor: pointer;
  overflow: hidden;
}
.image-preview:hover {
  border-color: #409eff;
}
.image-placeholder {
  color: #c0c4cc;
  font-size: 14px;
}
.md-hint { font-size: 11px; color: #909399; line-height: 1.4; margin-top: 2px; }
.md-hint.md-warn { color: #e6a23c; }
.field-hint { font-size: 11px; color: #909399; line-height: 1.4; margin-top: 2px; }
</style>
